import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';

import useStyles from './CollapseCard.styled';

const CollapseCard = ({
  title,
  children,
  badge,
  onCollapse,
  opened,
  className,
  headerJustifyContent,
  customClasses = {},
  id,
  tooltip = '',
  dataCy,
}) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    if (onCollapse) {
      onCollapse(!expanded);
    }
    setExpanded(!expanded);
  };

  useEffect(() => {
    setExpanded(opened);
    if (onCollapse) {
      onCollapse(opened, true);
    }
  }, [opened]) // eslint-disable-line

  return (
    <Box className={`${classes.root} ${customClasses.root} ${className || ''}`}>
      <Button
        id={id}
        fullWidth
        color="primary"
        variant="contained"
        className={clsx(classes.button, {
          [classes.expandOpen]: expanded,
          [customClasses.buttonClass]: true,
          [customClasses.buttonClassExtended]: expanded,
        })}
        endIcon={<ExpandMoreIcon />}
        onClick={handleExpandClick}
        data-cy={dataCy}
      >
        <Box display="flex" fontWeight="500" justifyContent={headerJustifyContent} width="100%">
          <Box display="flex" alignItems="center">
            {title}
            {tooltip ? 
              <Tooltip title={tooltip}>
                <InfoIcon className={classes.infoIcon} />
              </Tooltip> : null}
          </Box>
          {badge && badge}
        </Box>
      </Button>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box className={`${classes.box} ${customClasses.box}`}>{children}</Box>
      </Collapse>
    </Box>
  );
};

CollapseCard.propTypes = {
  id: PropTypes.string,
  badge: PropTypes.node,
  opened: PropTypes.bool,
  onCollapse: PropTypes.func,
  customClasses: PropTypes.object,
  title: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
  headerJustifyContent: PropTypes.string,
};

CollapseCard.defaultProps = {
  onCollapse: () => { },
  headerJustifyContent: 'space-between',
  id: new Date().getTime().toString(36),
};

export default CollapseCard;
